(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('oppExcessInventoryOverLeadTimeMultiple', oppExcessInventoryOverLeadTimeMultiple);

	function oppExcessInventoryOverLeadTimeMultiple($rootScope, $scope, $location, $state, redirectParamsService,
			leanFilterService, tableRenderService, $timeout, tableService, storeService, flexColumns, columnsService) {

		var vm = this;
		var unsubscribe;
		vm.getData = getData;
		vm.getMeta = getMeta;

		vm.showExcel = true;

		var columnList = columns();
		var pinnedColumnList = [];

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		vm.reportName = 'Excess inventory over lead time multiple';

		vm.broadcastExcel = function() {
			var exportFileName = reportSettingsId ? vm.reportName : undefined;
			$rootScope.$broadcast('export-excel', {columns: getExcelColumns(), doChooseColumns: true, exportFileName: exportFileName});
		};

		var reportSettingsName = 'excess-inventory-over-lead-time-multiple';

		var rendererParams = {
			uomId: 'purchasingUOM',
			multiFactory: true,
			specificTaskType: 'task'
		};

		var extraParams = [{
			showExcel: true,
			excelReportName: 'Opportunity'
		},{
			name: 'reportRule',
			value: 'ExcessOnHandOverLeadTime'
		}];
		if ($location && $location.search() && $location.search().excessType) {
			extraParams.push({
				name: 'excessType', value: $location.search().excessType
			});
		}

		var defaultFilters = [
			{ id: 'factory', values: [globalConfig.factory.id], 'isMandatory': true },
			{ id: 'itemGroupNdx', values: [leanFilterService.leanDnaAllSelected] },
			{ id: 'supplierNdx', values: [leanFilterService.leanDnaAllSelected] },
			{ id: 'buyerCode', values: [leanFilterService.leanDnaAllSelected] }
		];

		vm.extraFilters = [{
			'name': 'analysisMultipleLeadTimeFloat',
			'type': 'range',
			'comparator': 'Greater Than',
			'valueOne': 'leadTimeMultiple'
		}];

		leanFilterService.clearFilters();
		leanFilterService.useFactoryFilter = true;
		var siteFilter = leanFilterService.filterDefinitions['Factory'];
		siteFilter.type = 'multiselect';
		siteFilter.removable = false;
		var filters = {};
		filters.multiSelectFilters = [
			leanFilterService.filterDefinitions['BusinessUnit'],
			leanFilterService.filterDefinitions['Division'],
			leanFilterService.filterDefinitions['Entity'],
			siteFilter,
			leanFilterService.filterDefinitions['Item Group'],
			leanFilterService.filterDefinitions['Supplier'],
			leanFilterService.filterDefinitions['Buyer'],
			leanFilterService.filterDefinitions['Planner'],
			leanFilterService.filterDefinitions['ERP Order Policy'],
			leanFilterService.filterDefinitions['MaterialGroup'],
			leanFilterService.filterDefinitions['MaterialType'],
			leanFilterService.filterDefinitions['TaskStatus'],
			leanFilterService.filterDefinitions['TaskCategory'],
			leanFilterService.filterDefinitions['Responsible']
		];
		filters.rangeFilters = [
			leanFilterService.filterDefinitions.LeadTimeMultiple
		];
		filters = leanFilterService.addFlexFiltersBySourceType(['item'], filters);
		leanFilterService.setAllFilterLists(filters);
		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, columns()).then(function (response) {
				return response;
			});
		}

		function getExcelColumns() {
			return columns().concat([{id: 'daysDisplayType'}]);
		}

		function columns() {
			var cols = [
				{
					id: 'actionStatus',
					display: 'Task Status',
					renderer: tableRenderService.statusWithCircle,
					pinnedLeft: true,
					sort: false,
					width: 80
				}, {
					id: 'itemCode',
					display: 'Item Code',
					renderer: tableRenderService.itemCode,
					pinnedLeft: true,
					width: 180
				}, {
					id: 'itemGroupName',
					display: 'Item Group',
					width: 150
				}, {
					id: 'factoryName',
					display: 'Site'
				}, {
					id: 'supplierName',
					display: 'Supplier'
				}, {
					id: 'totalOnHandUnrestrictedQuantity',
					display: 'On Hand (Unrestricted)',
					renderer: tableRenderService.onHand
				}, {
					id: 'analysisExcessOnHandQuantityFloat',
					display: 'Excess On Hand Qty',
					renderer: tableRenderService.integer
				}, {
					id: 'excessOnHandValue',
					display: 'Excess On Hand Value',
					renderer: tableRenderService.currency
				}, {
					id: 'analysisExcessOnHandOverLTValue',
					display: 'Excess On Hand Over Lead Time',
					sortDefaultReverse: true,
					renderer: tableRenderService.currency
				}, {
					id: 'next30Days',
					display: 'On Order Next 30 Days',
					class: 'alignRight',
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 30
				}, {
					id: 'next60Days',
					display: 'On Order Next 60 Days',
					class: 'alignRight',
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 60
				}, {
					id: 'next90Days',
					display: 'On Order Next 90 Days',
					class: 'alignRight',
					renderer: tableRenderService.onOrderNextXDays,
					show: false,
					days: 90
				},
				{
					id: 'totalOnOrderQuantityFloat',
					display: 'On Order Qty',
					width: 80,
					show: false,
					renderer: tableRenderService.hyperlinkShortage
				}, {
					id: 'totalOnOrderValue',
					display: 'Total On Order Value',
					width: 80,
					show: false,
					renderer: tableRenderService.onOrderValue
				},
				{
					id: 'analysisExcessOnOrderQuantityFloat',
					display: 'Excess On Order Qty',
					renderer: tableRenderService.integer,
					show: false
				}, {
					id: 'excessOnOrderValue',
					display: 'Excess On Order Value',
					show: false,
					renderer: tableRenderService.currency
				}, {
					id: 'analysisTargetInventoryQty',
					display: 'Target Qty',
					class: 'alignRight',
					show: false,
					renderer: tableRenderService.targetQtyRenderer
				}, {
					id: 'estimatedSavings',
					display: 'Estimated Savings',
					show: false,
					renderer: tableRenderService.currency
				}, {
					id: 'weeklyOpportunityDelta',
					display: 'Weekly Opportunity Change',
					class: 'alignRight',
					renderer: tableRenderService.ppvRenderer,
					show: false
				}, {
					id: 'costPerItemFloat',
					display: 'Unit Price',
					renderer: tableRenderService.currency,
					show: false,
					'keepAllDecimals': true
				}, {
					id: 'purchasingUOM',
					display: 'UOM',
					show: false
				}, {
					id: 'abcClass',
					display: 'ABC Rank',
					show: false
				}, {
					id: 'totalOnHandQuantityFloat',
					display: 'Total On Hand Qty',
					renderer: tableRenderService.integer,
					show: false
				}, {
					id: 'currentOnHandCostFloat',
					display: 'Total On Hand Value',
					renderer: tableRenderService.currency,
					show: false
				}, {
					id: 'leadTimeInDaysFloat',
					display: 'Lead Time',
					class: 'alignRight',
					renderer: tableRenderService.leadTime,
					show: false
				}, {
					id: 'analysisMultipleLeadTimeFloat',
					display: 'Lead Time Multiple',
					renderer: tableRenderService.decimal
				}];
			cols = cols.concat(columnsService({
				analysisAvgDailyDemandFloat: 1,
				averageDailyDemandFromPastRqmts: 0,
				averageDailyDemandFromFutureRqmts: 0,
				isVmi: 0
			}));
			cols = cols.concat([
				{
					id: 'buyerCode',
					display: 'Buyer',
					show: false
				}, {
					id: 'planner',
					display: 'Planner',
					width: 100,
					show: false
				}, {
					id: 'analysisReplenishmentType',
					display: 'Recommended Policy',
					show: false
				}, {
					id: 'productHierarchy',
					display: 'Product Hierarchy',
					show: false
				}, {
					id: 'externalMaterialGroup',
					display: 'External Material Group',
					show: false
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				}
			]);
			cols = flexColumns.addFlexColumnsBySourceType(['item'], cols);
			return cols;
		}

		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			noPaging: false,
			pageSize: 50,
			defaultSort: 'analysisExcessOnHandOverLTValue',
			defaultSortDirection: 'desc',
			defaultFilters: defaultFilters,
			rendererParams: rendererParams,
			extraParams: extraParams,
			columns: columnList,
			reportUrl: '{0}/ItemReport/Opportunities/ExcessOnHandOverLeadTime',
			pinnedColumns: pinnedColumnList,
			hideSearch: false,
			footer: false,
			setColumnDefaults: true,
			excelRequest: true,
			useReportBuilderForExcel: true,
			excelReportName: 'Opportunity',
			hasMandatoryFilters: true
		};
		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = vm.reportName;
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();
